<div class="page">
  <mdb-navbar SideClass="navbar navbar-1  navbar-expand-lg fixed-top" [containerInside]="true">
    <mdb-navbar-brand>
      <a class="navbar-brand" href="#">
        <img src="../../assets/KG-sellers-hub-logo/KG-sellers-hub-logo.png" alt="" class="">
      </a>
    </mdb-navbar-brand>
    <links class="linksdata">
      <ul class="navbar-nav ml-auto items">

        <li class="nav-item waves-light ml-lg-5 ml-md-5 ml-sm-0 ml-0">
          <a class="nav-link nav_text">
            Kaiglo Express
          </a>

        </li>

        <li class="nav-item waves-light ml-lg-5 ml-md-5 ml-sm-0 ml-0" mdbWavesEffect>
          <a class="nav-link nav_text">Learning Center</a>
        </li>
        <li class="nav-item waves-light ml-lg-5 ml-md-5 ml-sm-0 ml-0" mdbWavesEffect>
          <a class="nav-link">
            <button class='nav_btn'>register</button>
          </a>
        </li>



      </ul>
    </links>
  </mdb-navbar>
  <div class="top">
    <div class="container">
      <p class="header_title">
        Join the No.1 <br>Ecommerce <br> Platform in Nigeria
      </p>
      <p class="header_subtitle">Start making money now, it's easy and free</p>
      <button class="header_btn">Become a seller</button>
    </div>

  </div>
  <div class="section_1">
    <div class="container">
      <img src="../../assets/circle-artifacts.svg" alt="" class="circle">
      <p class="title">How it works</p>
      <p class="section_1_subtitle mb_mobile">Become a member on the SellersHub platform by creating
        an account either using your
        social<br> media account or email account. Proceed to create store and begin upload of store details,<br> then
        await your
        dashboard where items can be uploaded and all inventory managed.</p>

      <div class="grid">
        <div class='app_card'>
          <div class="d-flex justify-content-center">
            <img src="../../assets/become_member.svg" alt="" class="">
          </div>
          <p class="app_card_title text-center">Become a member</p>
          <p class="app_card_subtitle text-center">Sign up to sell on SellersHub<br> and reach millions of<br> potential
            customers.</p>
        </div>
        <div class='app_card'>
          <div class="d-flex justify-content-center">
            <img src="../../assets/verify_acc.svg" alt="" class="">
          </div>
          <p class="app_card_title text-center">Upload product</p>
          <p class="app_card_subtitle text-center">Click on the verification link<br> sent to you to confirm your<br>
            registration</p>
        </div>
        <div class='app_card'>
          <div class="d-flex justify-content-center">
            <img src="../../assets/start-selling.svg" alt="" class="">
          </div>
          <p class="app_card_title text-center">Start Selling</p>
          <p class="app_card_subtitle text-center">Upload your products and<br> start selling!</p>
        </div>
      </div>
      <!-- <div class='swirl'> -->
      <img src="../../assets/swirle-libe/swirle-libe.png" alt="" class="swirl">
      <img src="../../assets/ring-artifacts.svg" alt="" class="ring">
      <img src="../../assets/Polygon1.svg" alt="" class="polygon">
      <!-- </div> -->
    </div>

  </div>

  <div id='skew1' class="cus-div">
    <div class="section_2">
      <div class="container">
        <div class="">
          <p class="title pt-5">Why choose SellersHub</p>
          <p class="section_2_subtitle">SellersHub provides the right platform for sellers to promote their brand and
            store online,<br> allowing them to have personalized interaction with potential buyers.</p>
        </div>
        <div class="section_2_grid">
          <div class="pt-5">
            <div class="cc p-3">
              <div class="row">
                <div class="col-9">
                  <p class="why_text text-right">Market Coverage</p>
                  <p class="why_subtext text-right">we understand your need to reach a broader consumer base and make
                    smoother
                    sales and huge
                    profits; SellersHub as a platform is here to help.</p>
                </div>
                <div class="col-3">
                  <img src="../../assets/market-coverage.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
              </div>
            </div>

            <div class="cc p-3">
              <div class="row">
                <div class="col-9">
                  <p class="why_text text-right">Trade Experience</p>
                  <p class="why_subtext text-right">SellersHub provides a user experience that allows even your most
                    loyal
                    customers to still
                    keep in touch and purchase from you anywhere they are in Nigeria.</p>
                </div>
                <div class="col-3">
                  <img src="../../assets/Trade-experience.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
              </div>
            </div>


            <div class="cc p-3">
              <div class="row">
                <div class="col-9">
                  <p class="why_text text-right">Easy of transaction</p>
                  <p class="why_subtext text-right">On SellersHub, mobile payment is made easy, fast and efficient.</p>
                </div>
                <div class="col-3">
                  <img src="../../assets/easy-of-transaction.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
              </div>
            </div>

          </div>

          <div class="d-flex justify-content-center">
            <img src="../../assets/mobile-home/mobile-home.png" alt="" class="">
          </div>

          <div class="pt-5">
            <div class="cc p-3">
              <div class="row">
                <div class="col-3">
                  <img src="../../assets/brand-rec.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
                <div class="col-9">
                  <p class="why_text text-left">Brand recognition</p>
                  <p class="why_subtext text-left">Do you yearn for a platform where your brand image can be improved
                    and
                    recognized? The
                    SellersHub platform is perfect.</p>
                </div>
              </div>
            </div>

            <div class="cc p-3">
              <div class="row">
                <div class="col-3">
                  <img src="../../assets/market-insight.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
                <div class="col-9">
                  <p class="why_text text-left">Market insight</p>
                  <p class="why_subtext text-left">SellersHub ensures that you can monitor your sales annually to know
                    if you are
                    excelling
                    at
                    a particular trade to make better decision.</p>
                </div>
              </div>
            </div>


            <div class="cc p-3">
              <div class="row">
                <div class="col-3">
                  <img src="../../assets/efficiency.svg" alt="" class="wy_icon">
                  <div class="green_bg"></div>
                </div>
                <div class="col-9">
                  <p class="why_text text-left">Efficiency & trustworthy</p>
                  <p class="why_subtext text-left">Issue of quality and efficient service delivery is our watch word at
                    SellersHub.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div id='skew2' class="cus-div">
    <div class="section_3">
      <div class="container">
        <p class="text-center title mb">Successful stories</p>
        <div class="mt-5">
          <div class="row desktop">
            <div class="col-3 ct">
            </div>
            <div class="col-9 col- p-5 tc">
              <div class=" pl">
                <button class="seller_obi_btn pt-2">Store Owner</button>
                <p class='my_story mt-4'>My Story</p>
                <p class="my_story_text mb-5">Ever since I joined kaiglo, I have experienced improved sales due to<br>
                  their
                  market
                  insight
                  data.
                </p>

              </div>
              <div class="pl">
                <p class="obinna">ObinnaBoss</p>
                <p class="ceo">CEO (ObinnaBoss Fashion)</p>
                <ul>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle " style='color:#FFB300'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                </ul>
                <div class="img_arrow">
                  <img src="../../assets/bxs-right-arrow-circle.svg" alt="" class="">
                </div>
              </div>
            </div>
            <div class="seller_obi">
              <img src="../../assets/seller-obinnapro/seller-obinnapro.png" alt="" class="seller_obi_img">
            </div>
          </div>


          <div class="mobile">
            <div class="mobile_grid">
              <div class="p-0 t" style='height:300px; background:black; border-radius: 10px 0px 0px 10px;'>
              </div>
              <div class="p-0 t" style='height:300px; background:"#ffffff"; border-radius: 0px 10px 0px 0px'>
              </div>
            </div>
            <div class="col-12" style='background:"#ffffff"; border-radius: 0px 0px 10px 10px;'>
              <div class="pt-4">
                <button class="seller_obi_btn pt-2">Store Owner</button>
                <p class='my_story mt-4'>My Story</p>
                <p class="my_story_text">Ever since I joined kaiglo, I have experienced improved sales due to
                  their
                  market
                  insight
                  data.
                </p>

              </div>
              <div class="pb-3">
                <p class="obinna">ObinnaBoss</p>
                <p class="ceo">CEO (ObinnaBoss Fashion)</p>
                <ul class=''>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle " style='color:#FFB300'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                  <li class='mr-3'>
                    <mdb-icon fas icon="circle" style='color:#DFDFDF'></mdb-icon>
                  </li>
                </ul>
                <div class="img_arrow">
                  <img src="../../assets/bxs-right-arrow-circle/bxs-right-arrow-circle.png" alt="" class="">
                </div>
              </div>
            </div>
            <div class="seller_obi ">
              <img src="../../assets/seller-obinnapro/seller-obinnapro.png" alt="" class="seller_obi_img">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="app_footer py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-12 col-12">
          <p class="footer_header">Company information</p>
          <p class="footer_text">Contact Us</p>
          <p class="footer_text">Terms and Conditions</p>
          <p class="footer_text">Privacy Policy</p>
          <p class="footer_text">About Us</p>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-12">
          <p class="footer_header">Customer Service</p>
          <p class="footer_text">Shipping & Delivery</p>
          <p class="footer_text">SellersHub Express</p>
          <p class="footer_text">Return Policy</p>

        </div>
        <div class="col-lg-2 col-md-2 col-sm-12 col-12">
          <p class="footer_header">Kaiglo Social</p>
          <ul class="">
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="facebook-f"></mdb-icon>
            </li>
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="twitter"></mdb-icon>
            </li>
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="instagram"></mdb-icon>
            </li>
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="telegram-plane"></mdb-icon>
            </li>
          </ul>
          <ul class="">
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="facebook-messenger"></mdb-icon>
            </li>
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="youtube"></mdb-icon>
            </li>
            <li class='mr-3' style="cursor: pointer;">
              <mdb-icon fab icon="pinterest"></mdb-icon>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
          <p class='footer_header'>Make money with us</p>
          <p class='footer_text'>Sell on SellersHub </p>
          <p class='footer_text'>Become an Affiliate Partner</p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
          <p class="footer_header">Download our Mobile App!</p>
          <ul class="">
            <li style="cursor: pointer;"><img src="../../assets/google@/google@.png" alt="" class="mr-3"></li>
            <li style="cursor: pointer;"><img src="../../assets/apple@/apple@.png" alt="" class=""></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-4 pb-3 desktop">
    <p class="copyright mb-0">Copyright © 2020 SELLERSHUB STORES LIMITED. All Rights Reserved. User Agreement,<span
        style="color:#4186D9">Privacy and
        Cookies</span></p>
  </div>
  <div class="pt-4 pb-3 mobile">
    <p class="copyright mb-0">Copyright © 2020 SELLERSHUB STORES <br> LIMITED. All Rights Reserved.<br> User
      Agreement,<span style="color:#4186D9">Privacy and
        Cookies</span></p>
  </div>
</div>
